import React, { useState } from "react";
import { message } from "antd";
import { Share2, Copy, Check, ChevronRight } from "lucide-react";

const AmbassadorApplicantLinksCard = ({ referralLink = "", onOpenDrawer }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!referralLink) {
      if (onOpenDrawer) onOpenDrawer();
      return;
    }
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    message.success("Referral link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm text-left">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="bg-gray-900 p-2.5 rounded-xl text-white flex-shrink-0 shadow-xs">
            <Share2 className="w-5 h-5 text-white" />
          </div>
          <div className="min-w-0">
            <h3 className="font-gilroyBold text-base text-gray-900 m-0">
              Your Referral Link
            </h3>
            <p className="text-gray-500 text-[13px] m-0 mt-0.5 leading-relaxed truncate">
              Share to earn commissions on marketplace & businesses
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={onOpenDrawer}
          className="text-xs font-gilroyBold text-emerald-700 hover:text-emerald-800 bg-emerald-50/80 hover:bg-emerald-100/70 px-2.5 py-1.5 rounded-xl border border-emerald-200/60 flex items-center gap-1 cursor-pointer transition flex-shrink-0 whitespace-nowrap"
        >
          <span>All 4 Links</span>
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>

      <div className="mt-3.5 flex items-center gap-2">
        <div className="flex-1 min-w-0 bg-gray-50 border border-gray-200/80 rounded-xl px-3 py-2 text-[13px] text-gray-600 font-mono truncate select-all">
          {referralLink || "https://konnect.com/register?ref=..."}
        </div>
        <button
          type="button"
          onClick={handleCopy}
          className="bg-emerald-600 hover:bg-emerald-700 text-white font-gilroyBold text-[13px] px-3.5 py-2 rounded-xl border-0 shadow-xs flex items-center gap-1.5 cursor-pointer flex-shrink-0 transition-all active:scale-95"
        >
          {copied ? (
            <>
              <Check className="w-4 h-4" />
              <span>Copied</span>
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              <span>Copy</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default AmbassadorApplicantLinksCard;
